<template>
  <div id="Contact" >
    <b-container>
        <b-row>
            <b-col>
                <h3 class="title">Ready to Learn More?</h3>
                <p class="description" >Whether you’re running a private club or hosting professional tournaments, PinPos can help you elevate your course setup.
                     Fill out the form and a member of our team will be in touch to discuss how PinPos can work for your venue.</p>
                <transition name="fade" mode="out-in">
                  <div class="thanksBox" v-show="result == true">
                    <p class="thanksText">Thanks for contacting us, we will get back to you shortly...</p>
                  </div>
                </transition>
                <template v-if="result != true">
                  <b-form @submit.prevent="submitForm">
                    <b-form-input type="text" v-model="name" placeholder="Full Name"></b-form-input>
                    <b-form-input type="text" v-model="email" placeholder="Email Address"></b-form-input>
                    <b-form-input type="text" v-model="club" placeholder="Golf Club"></b-form-input>
                    <b-form-textarea
                      id="textarea"
                      v-model="message"
                      placeholder="Message"
                    ></b-form-textarea>
                    <b-button class="getintouch" data-text="submit" type="submit">Submit</b-button>
                    <div class="g-recaptcha" data-sitekey="6LeQd9IrAAAAAMpSiPd53G0PnDsp8-xKtRPhlrbo"></div>
                  </b-form>
                </template>
            </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
// support@ocs-software.com key
const WEB3FORMS_ACCESS_KEY = "a24ddb1c-d5d1-46a9-b176-14e540c4ea27";
// matt.edmeads@ocs-software key for testing
// const WEB3FORMS_ACCESS_KEY = "7c7b6d13-39f5-42e2-9047-8155a7f86557"

import axios from 'axios'
export default {
  name: 'Contact Section',
  components: {

  },
  data: function() {
    return {
      acf: [],
      website: 'Pin Position Website Enquiry',
      name: '',
      email: '',
      club: '',
      message: '',
      result: '',
    };
  },
  methods: {
    // isMobile() {
    //     if( screen.width <= 768 ) {
    //         return true;
    //     }
    //     else {
    //         return false;
    //     }
    // },
      async submitForm() {
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            access_key: WEB3FORMS_ACCESS_KEY,
            website: this.website,
            name: this.name,
            email: this.email,
            club: this.club,
            message: this.message,
          }),
        });
        const result = await response.json();
        if (result.success) {
          console.log(result);
          this.result = result.success;
          this.text = 'Thanks for contacting us, we will get back to you shortly...'
        }
      },
  },
  mounted() {
    axios //add API Call
        .get(
           process.env.VUE_APP_API_URL + 'pinpos' + "/wp-json/wp/v2/pages/13" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>
<style scoped>
::v-deep .g-recaptcha > div {
  width: auto!important;
  margin-top: 20px;
}
textarea#textarea {
    height: 250px;
}
p.thanksText {
  color: #0054E8;
  font-weight: bold;
}
.form-control {
    display: block;
    width: 812px;
    height: 64px;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #B7B7B7;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 14px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    margin-bottom: 15px !important;
    margin: auto;
    display: block;
}
#Contact {
    padding-top: 100px;
    padding-bottom: 100px;
}
.title {
    font-size: 50px;
    font-family: DIN Condensed, Bold;
    color: #0054E8;
    text-align: center;
}
p {
    text-align: center;
    font-size: 24px;
    color: #000000;
    padding-bottom: 50px;
}
button.getintouch {
    padding: 14px 14px 14px 14px;
    background-color: #2CD55B;
    height: 64px;
    color: #fff;
    border-radius: 14px;
    border-color: #2CD55B;
    font-size: 24px;
    font-weight: bold;
    width: 278px;
    margin-top: 20px;
}
button.getintouch:hover {
    padding: 14px 14px 14px 14px;
    background-color: #0054E8;
    height: 64px;
    color: #fff;
    border-radius: 14px;
    border-color: #0054E8;
    font-size: 24px;
    font-weight: bold;
    width: 278px;
    margin-top: 20px;
}

/* Css for mobile */
@media only screen and (max-width: 1280px) {
    #Contact {
        padding-top: 50px;
        padding-bottom: 50px;
    }
    .title {
        padding-bottom: 20px;
    }
    p {
        text-align: left;
        font-size: 18px;
        color: #000000;
        padding-bottom: 0px;
    }
  .form-control {
      display: block;
      width: 100%;
      height: 64px;
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #B7B7B7;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 14px;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      margin-bottom: 15px !important;
      margin: auto;
      display: block;
  }
  button.getintouch {
      padding: 14px 14px 14px 14px;
      background-color: #2CD55B;
      height: 64px;
      color: #fff;
      border-radius: 14px;
      border-color: #2CD55B;
      font-size: 18px;
      font-weight: bold;
      width: 100%;
      margin-top: 20px;
  }
  button.getintouch:hover {
      padding: 14px 14px 14px 14px;
      background-color: #0054E8;
      height: 64px;
      color: #fff;
      border-radius: 14px;
      border-color: #0054E8;
      font-size: 18px;
      font-weight: bold;
      width: 100%;
      margin-top: 20px;
  }
}
</style>
